import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

export default createReactClass({
	displayName: 'ProductWizardResultInfo',

	propTypes: {
		item: PropTypes.object.isRequired,
		languageCode: PropTypes.string,
		region: PropTypes.string,
		apiUrl: PropTypes.string
	},

	componentDidMount() {
		const element = this.refs.placeholder;
		const widget = new window.SlxItemsheetWidget({
			id: this.props.item.id,
			language: this.props.languageCode,
			region: this.props.region,
			apiUrl: this.props.apiUrl
		});
		widget.renderTo(element);
	},

	render() {
		return (
			<div className="slx-product-wizard-list-item-info">

				<div
					className="slxproducts-specsheet"
					ref="placeholder"
					role="main"
				>
				</div>
			</div>
		);
	}
});
